import React, { useState } from 'react';
import PropTypes from 'prop-types';

const ArticleEmbed = ({ url, index }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  return (
    <div className="max-w-[600px]">
      <div className="relative" style={{ paddingBottom: '56.25%' }}>
        {!isLoaded && !hasError && (
          <div className="absolute inset-0 flex items-center justify-center bg-card rounded-lg">
            <div className="animate-pulse">Loading article preview...</div>
          </div>
        )}
        
        {hasError ? (
          <div className="absolute inset-0 p-4 bg-card rounded-lg flex flex-col items-center justify-center">
            <p className="text-muted mb-2">Article preview unavailable</p>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              View article
            </a>
          </div>
        ) : (
          <iframe
            src={`${process.env.REACT_APP_API_BASE_URL}/api/embed?url=${encodeURIComponent(url)}`}
            title={`Article ${index + 1}`}
            className={`absolute top-0 left-0 w-full h-full rounded-lg ${isLoaded ? 'visible' : 'invisible'}`}
            sandbox="allow-scripts allow-same-origin"
            onLoad={() => setIsLoaded(true)}
            onError={() => setHasError(true)}
          />
        )}
      </div>
      {isLoaded && !hasError && (
        <div className="mt-2 text-sm text-muted break-all">
          {url}
        </div>
      )}
    </div>
  );
};

ArticleEmbed.propTypes = {
  url: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};

export default ArticleEmbed;
